<template>
    <div class="mr-snap-title standard">
        <div v-if="isMobileSize" class="title-container">
            <div class="mobile">
                <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <div v-if="time">{{ time }}</div>
            </div>
            <a
                :href="featureAreaMarketRefineLink()"
                v-if="featureAreaMarketRefineLink&&featureAreaMarketRefineLink()"
                rel="noopener noreferrer"
                class="refine-market"
            ><i class="iconfont icon-community"></i
            >{{ $t('md-snapshot-search.refineSearch') }}</a
            >
        </div>
        <div v-else class="title-container">
            <div class="pc">
                <div class="mg-title" v-if="title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <span class="time" v-if="time">{{ time }}</span>
            </div>
            <a
                :href="featureAreaMarketRefineLink()"
                v-if="featureAreaMarketRefineLink&&featureAreaMarketRefineLink()"
                rel="noopener noreferrer"
                class="refine-market"
            ><i class="iconfont icon-community"></i
            >{{ $t('md-snapshot-search.refineSearch') }}</a
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'snap-title',
    i18next: {
        ns: 'md-snapshot-search'
    },
    props: {
        title: {
            type: String,
            required: true
        },
        time: String // market snapshot  next time
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    inject: ['featureAreaMarketRefineLink']
};
</script>

<style lang="scss">
.mr-snap-title.standard {
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .refine-market {
        font-size: 14px;
        color: #505050;
        font-family: var(--font-medium);
        line-height: 26px;
        display: flex;
        align-items: center;
        .iconfont.icon-community {
            margin-right: 10px;
            color: #a8a8a8;
        }
    }

    .pc {
        padding: 40px 0 20px 0;
        .mg-title {
            width: auto;
        }
        .time {
            font-size: 16px;
        }
    }
    .mobile {
        .mg-title {
            width: auto
        }
        .desc {
            margin-bottom: 15px;
        }
    }
    .desc {
        margin-right: 10px;
    }
    .time {
        font-family: var(--font-normal);
        font-size: 14px;
        color: var(--color-label);
    }
    .title-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
}
</style>
